/**
 * @description Can be swapped with the primary success color.
 */

const moss = {
  25: "#FAFDF7",
  50: "#F5FBEE",
  100: "#E6F4D7",
  200: "#CEEAB0",
  300: "#ACDC79",
  400: "#86CB3C",
  500: "#669F2A",
  600: "#4F7A21",
  700: "#3F621A",
  800: "#335015",
  900: "#2B4212",
  950: "#1A280B",
};

export default moss;
